import contractMapSelector from 'app/App/selectors/contractMap';
import cwdSiteRootSelector from 'app/Tree/selectors/cwdSiteRoot';
import lanIdSelector from 'app/UserInfo/selectors/lanId';
import { createNewComponentObject } from 'utils/factory';

import { createNewComponent } from './actions';

/**
 * create a new master component
 *
 * @param {object} params - function params
 * @param {string} params.componentVariation - component variation of the selected component
 * @param {object} params.renderingEnv - rendering env object of the selected component
 * @returns {Function} thunk to create a new master component
 */
export const createNewMasterComponentThunk = ({ componentVariation, renderingEnv }) => (
  dispatch,
  getState
) => {
  const state = getState();
  const contractMap = contractMapSelector(state);
  const cwdSiteRoot = cwdSiteRootSelector(state);
  const lanId = lanIdSelector(state);

  const payload = createNewComponentObject({
    componentVariation,
    cwdSiteRoot,
    renderingEnv,
    canvasContract: contractMap[componentVariation],
    isMaster: true,
    userLanId: lanId
  });
  dispatch(createNewComponent(payload));
};
